// extracted by mini-css-extract-plugin
export default {"tableHeader":"ExpandableTable_tableHeader__Ok6c+","registros":"ExpandableTable_registros__R2rGH","expandButton":"ExpandableTable_expandButton__QM8Ij"};